import { RequestError } from "@/app/common/types_and_interfaces"
import { AppDispatch, RootState } from "../store"
import { createAsyncThunk } from "@reduxjs/toolkit"

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
    state: RootState
    dispatch: AppDispatch
    rejectValue: RequestError
  }>()
  


  